import React from "react";
import Banner from "../../Components/Banner";
import Footer from "../../Components/Footer";
import { motion } from "framer-motion";
import AboutUsInitialSection from "./Sections/AboutUsInitial/AboutUsInitial";
import AboutFounderMessageSection from "./Sections/AboutFounderMessage/AboutFounderMessage";
import AboutUsVisionSection from "./Sections/AboutUsVision/AboutUsVision";
import AboutUsApproachSection from "./Sections/AboutUsApproach/AboutUsApproach";
import WorkedOnSection from "../../Components/WorkedOnSection";
import Header from "../../Components/Header";
import GradientGlowDivider from "../../Components/GradientGlowDivider";
import OurFounderCard from "../Careers/Sections/Components/OurFounderCard";
import BlackButton from "../../Components/BlackButton";
import CareersJoinUsSection from "../Careers/Sections/CareersJoinUs/CareersJoinUs";

const AboutUsPage = () => {
  return (
    <motion.div
      className="flex flex-col"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <div className="sticky md:static top-0 md:top-auto z-50 md:z-0 bg-app-background md:bg-transparent">
        <Header />
        <div className="w-[90%] mx-auto hidden md:block">
          <GradientGlowDivider />
        </div>
      </div>
      <AboutUsInitialSection />
      <AboutUsVisionSection />
      <AboutFounderMessageSection message="We bridge the gap left by large consulting firms and system integrators by combining strategic vision with execution. While consulting firms often focus solely on roadmaps and integrators lack strategic depth, we offer comprehensive AI solutions, including strategy, use case definition, infrastructure design, product integration, and talent development." />
      <AboutUsApproachSection />
      <div className="p-4 md:p-0 md:px-[8%] mt-[4%] flex flex-col items-center">
        <BlackButton
          className="md:mb-12"
          text="Meet our founder"
          padding="py-1 md:py-2 px-2 md:px-4"
          textClassName="text-sm md:text-lg font-normal font-theBrittanySans"
        />
        <OurFounderCard
          title="Gaurav Dixit"
          position="Founder | AI Strategist | Innovation Leader"
          description="Gaurav Dixit is an AI strategist and entrepreneur with over 15 years of experience in AI-driven business transformation. He has led AI initiatives at Ericsson and DataRobot, built multiple AI startups, and specializes in AI strategy, scalable architecture, and venture building. With a background in AI research and an MBA from IIM Lucknow, he continues to drive innovation and advise AI startups globally."
        />
      </div>
      <CareersJoinUsSection />
      <WorkedOnSection showExploreMore={true} />
      <Banner title="Want to work with us?" subtitle="Let's Talk!" />
      <Footer />
    </motion.div>
  );
};

export default AboutUsPage;
